import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Snaptura - Screenshot & PDF Generation API',
  description = 'Powerful screenshot and PDF generation API. Capture any website with advanced features like device emulation, ad blocking, and custom CSS. Start free.',
  image = 'https://snaptura.online/og-image.png',
  url = 'https://snaptura.online',
  type = 'website',
  keywords = 'screenshot API, PDF generation, website screenshot, headless browser, automation, web scraping, puppeteer API, screenshot service',
  author = 'Snaptura'
}) => {
  // Ensure URL is absolute
  const absoluteUrl = url.startsWith('http') ? url : `https://snaptura.online${url}`;
  const absoluteImage = image.startsWith('http') ? image : `https://snaptura.online${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={absoluteUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={absoluteImage} />
      <meta property="og:site_name" content="Snaptura" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={absoluteUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={absoluteImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={absoluteUrl} />
    </Helmet>
  );
};

export default SEO;
